'use client'

import { unescape } from 'lodash'
import { useEffect, useState } from 'react'

import { cn } from '@src/utils/tailwind'

export interface AnimatedSliderProps {
  sliders?: Array<{
    reverseDirection?: boolean
    imageSrc: string
  }>
  isDarkFade?: boolean
}

const useImageWidth = (src: string) => {
  const [width, setWidth] = useState(2000)

  useEffect(() => {
    const image = new Image()
    image.src = src
    image.onload = () => {
      setWidth(image.width)
    }
  }, [src])

  return width
}

const Rail = ({ reverse, imageSrc }: { reverse?: boolean; imageSrc: string }) => {
  const width = useImageWidth(imageSrc)

  return (
    <div
      className={cn('h-[100px] bg-contain bg-repeat-x lg:h-[164px]')}
      style={{
        backgroundImage: unescape(`url(&quot;${imageSrc}&quot;)`),
        width: width * 3,
        animation: reverse ? 'var(--animate-scroll-right)' : 'var(--animate-scroll-left)',
      }}
    ></div>
  )
}

const FadeBlock = ({ isRight, isDarkFade }: { isRight?: boolean; isDarkFade?: boolean }) => (
  <span
    className={cn(
      'pointer-events-none absolute z-10 h-full w-24 bg-gradient-to-r from-white to-white/0 lg:w-full lg:max-w-lg',
      {
        'right-0': isRight,
        'from-white/0 to-white': isRight,
        'from-[#1D1F20] to-black/0': isDarkFade && !isRight,
        'from-black/0 to-[#1D1F20]': isDarkFade && isRight,
      }
    )}
  ></span>
)

export const AnimatedSlider = ({ sliders = [], isDarkFade }: AnimatedSliderProps) => {
  if (sliders.length === 0) return null

  return (
    <div className="relative flex flex-col gap-[18px] overflow-hidden">
      {sliders.map((slider, index) => (
        <Rail key={index} imageSrc={slider.imageSrc} reverse={slider.reverseDirection} />
      ))}
      <FadeBlock isDarkFade={isDarkFade} />
      <FadeBlock isRight isDarkFade={isDarkFade} />
    </div>
  )
}
